import label from "@/lang/StaticLabels.js";

// PPARSINA Router  - مدیریت سیستم  -----------------------------------------------
let routeItems = {
  path: "parsinaSupport",
  name: "ParsinaSupport",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // redirect: "/parsinaSupport/dashboard",
  children: [
    {
      path: "/parsinaSupport/login",
      name: "parsinaSupportLogin",
      meta: {
        label: label.page.login,
        requiresAuth: false,
        requireParsinaSupportAuth: false,
      },
      component: () => import("@/views/auth/parsinaSupportLogin"),
    },
    {
      path: "dashboard",
      name: "PPARSINADashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pparsina,
        requiresAuth: false,
        requireParsinaSupportAuth: true,
      },
      component: () => import("@/views/modules/pparsina/Dashboard"),
    },
    {
      path: "company",
      name: "PPARSINACompany",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "company/list",
      children: [
        {
          path: "list",
          name: "PPARSINACompanyList",
          component: () => import("@/views/modules/pparsina/company"),
          meta: {
            label: label.page.company,
            requiresAuth: false,
            requireParsinaSupportAuth: true,
          },
        },
        {
          path: "add",
          name: "PPARSINAAddCompany",
          component: () => import("@/views/modules/pparsina/company/Info"),
          meta: {
            label: label.page.addCompany,
            requiresAuth: false,
            requireParsinaSupportAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PPARSINAEditCompany",
          component: () => import("@/views/modules/pparsina/company/Info"),
          meta: {
            label: label.page.editCompany,
            requiresAuth: false,
            requireParsinaSupportAuth: true,
          },
        },
      ],
    },
    {
      path: "backup",
      name: "PPARSINABackup",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "backup/import",
      children: [
        {
          path: "import",
          name: "PPARSINABackupImport",
          component: () => import("@/views/modules/pparsina/backup/Import"),
          meta: {
            label: label.page.backupImport,
            requiresAuth: false,
            requireParsinaSupportAuth: true,
          },
        },
        {
          path: "winImport",
          name: "PPARSINAWinBackupImport",
          component: () => import("@/views/modules/pparsina/backup/WinImport"),
          meta: {
            label: label.page.winBackupImport,
            requiresAuth: false,
            requireParsinaSupportAuth: true,
          },
        },
        {
          path: "export",
          name: "PPARSINABackupExport",
          component: () => import("@/views/modules/pparsina/backup/Export"),
          meta: {
            label: label.page.backupExport,
            requiresAuth: false,
            requireParsinaSupportAuth: true,
          },
        },
      ],
    },
    {
      path: "menu",
      name: "PPARSINAMenu",
      component: () => import("@/views/modules/pparsina/menu"),
      meta: {
        label: label.page.menuManagement,
        requiresAuth: false,
        requireParsinaSupportAuth: true,
      },
    },
    {
      path: "relationField",
      name: "PPARSINARelationField",
      component: () => import("@/views/modules/pparsina/relationField"),
      meta: {
        label: label.page.relationField,
        requiresAuth: false,
        requireParsinaSupportAuth: true,
      },
    },
    {
      path: "marketItem",
      name: "PPARSINAMarketItem",
      component: () => import("@/views/modules/pparsina/marketItem"),
      meta: {
        label: label.page.marketItem,
        requiresAuth: false,
        requireParsinaSupportAuth: true,
      },
    },
  ],
};

export default routeItems;
